import { Theme } from "@mui/material/styles";
import { keyframes } from "@mui/system";

// -----------------------------
// Animations
// -----------------------------
export const typingAnimation = keyframes`
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  40% {
    opacity: 1;
    transform: scale(1.3);
  }
`;

// -----------------------------
// Styles
// -----------------------------
export const styles: Record<string, any> = {
    modal: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        overflow: "hidden",
    },

    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 3,
        pl: 3,
        pr: 2,
        borderBottom: (theme: Theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: (theme: Theme) => theme.palette.primary.main,
        color: "white",
    },

    content: {
        flex: 1,
        overflowY: "auto",
        padding: 2,
    },

    empty: {
        textAlign: "center",
        marginTop: 2,
    },

    footer: {
        px: 2,
        pt: 2,
        pb: 2.5,
        borderTop: (theme: Theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: (theme: Theme) => theme.palette.background.paper,
    },

    inputShell: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 1.5,
        border: (theme: Theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        bgcolor: (theme: Theme) => theme.palette.background.paper,
    },

    inputField: {
        flex: 1,
        "& .MuiInputBase-root": {
            alignItems: "flex-start",
            fontSize: 14.5,
            lineHeight: 1.45,
            padding: 0,
        },
        "& .MuiInputBase-input": {
            padding: 0,
        },
        "& .MuiInput-root:before, & .MuiInput-root:after": {
            display: "none",
        },
    },

    sendButton: {
        alignSelf: "center",
        width: 40,
        height: 40,
        color: (theme: Theme) => theme.palette.primary.main,
        "&.Mui-disabled": {
            color: (theme: Theme) => theme.palette.action.disabled,
        },
    },

    resetContainer: {
        display: "flex",
        justifyContent: "center",
        mt: 1,
        mb: 1,
    },

    navigateBackContainer: {
        display: "flex",
        justifyContent: "center",
    },

    timestamp: {
        textAlign: "center",
        fontSize: 12,
        color: (theme: Theme) => theme.palette.text.secondary,
        my: 1,
        opacity: 0.7,
    },

    userBubble: {
        py: 1,
        px: 1.5,
        ml: 8,
        background: (theme: Theme) => theme.palette.primary.lighter,
        borderRadius: 2,
        whiteSpace: "pre-wrap",
    },

    aiBubble: {
        py: 1,
        px: 1.5,
        mr: 8,
        background: (theme: Theme) => theme.palette.secondary.lighter,
        borderRadius: 2,
        minWidth: 54,
        overflowWrap: "break-word",
        wordBreak: "break-word",
    },

    avatar: {
        width: 24,
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    typingContainer: {
        display: "flex",
        gap: 1,
        alignItems: "center",
        height: 20,
    },

    dot: (theme: Theme) => ({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: theme.palette.secondary.main,
        animation: `${typingAnimation} 1.4s infinite`,
    }),

    dotDelay1: (theme: Theme) => ({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: theme.palette.secondary.main,
        animation: `${typingAnimation} 1.4s infinite`,
        animationDelay: "0.2s",
    }),

    dotDelay2: (theme: Theme) => ({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: theme.palette.secondary.main,
        animation: `${typingAnimation} 1.4s infinite`,
        animationDelay: "0.4s",
    }),
};